import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { WalkIcon, CaloryIcon, TimeIcon, DidimIcon } from '../../../../assets/images/activityIcons';
import ExerciseDataItem from '../exerciseDataItem';

const MonthlySummary = ({
    month,
    goalDays,
    achievedDays,
    stepCount = -1,
    calories,
    time,
    isCurrentMonth = false,
    isDidim = false,
    sx = {},
    ...props
}) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                padding: '0px 10px 0 10px',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
                alignSelf: 'stretch',
                ...sx,
            }}
            {...props}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                gap: '10px',
                alignSelf: 'stretch',
            }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        gap: '5px',
                        flex: '1 0 0',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '20px',
                            fontWeight: 600,
                            letterSpacing: '-0.6px',
                        }}
                    >
                        {month}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '12px',
                            color: theme.palette.figma.white[60],
                            fontWeight: 400,
                            letterSpacing: '-0.36px',
                            textAlign: 'right',
                        }}
                    >
                        {t('achieved_of_goal_days_achieved', { achieved: achievedDays, goal: goalDays })}
                    </Typography>
                </Box>

                {/* 운동 데이터 */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        gap: '5px',
                        flex: '1 0 0',
                    }}
                >
                    {/* Steps */}
                    <ExerciseDataItem
                        icon={isDidim ? DidimIcon : WalkIcon}
                        value={stepCount}
                        unit={t('didim')}
                        iconColor={isDidim ? theme.palette.figma.didim : theme.palette.figma.steps}
                        size="small"
                    />

                    {/* Calories */}
                    <ExerciseDataItem
                        icon={CaloryIcon}
                        value={calories}
                        unit="kcal"
                        iconColor={theme.palette.figma.calorieRed}
                        size="small"
                    />

                    {/* Time */}
                    <ExerciseDataItem
                        icon={TimeIcon}
                        value={time}
                        unit={t('min')}
                        iconColor={theme.palette.figma.time}
                        size="small"
                    />
                </Box>

            </Box>
            {/* 월 정보 */}

        </Box >
    );
};

export default MonthlySummary;
